import { Window } from '@execonline-inc/browser-window.private';
import { Button, ArrowUpRightFromSquareIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

function ModalDescription() {
  return (
    <div className="mt-10 gap-3 flex flex-col">
      <Typography color="charcoal" variant="bodyMedium" fontWeight="semibold" className="leading-6">
        <T kind="What is a Learning Collection?" />
      </Typography>
      <Typography color="dark" variant="bodyMedium" className="leading-5">
        <T kind="A Learning Collection is a curated suite of programs organized into one or more sections, with each section including programs focused on your specific objective(s). You can customize your learning collections and share them with specific individuals or groups, making it simple to manage and deliver your talent initiatives." />
      </Typography>
      <Button
        className="flex flex-row items-center justify-start p-0"
        variant="link"
        onClick={() =>
          Window.openWindow(
            'https://support.execonline.com/en/collections/11401771-learning-collections',
            '_blank',
          )
        }
      >
        <Typography variant="bodySmall" fontWeight="semibold" color="teal">
          <T kind="Learn more about learning collections" />
        </Typography>
        <ArrowUpRightFromSquareIcon color="teal" size="sm" />
      </Button>
    </div>
  );
}

export default observer(ModalDescription);
